import { computed, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  requestPayload,
  NewsItem,
  Promotions,
  Ratecap,
  requestNewsItemPayload,
  requestforEmulationPayload,
} from '../models/model';
import { ErrorhandlerService } from './errorhandler.service';
import { environment } from '../../../environments/environment';
import { apiUrl } from '../../config/api-url';
import { Products } from '../models/productsModel';
import config from '../../../assets/config.json';
import { switchAdvisorService } from './switchAdvisorService';
import { AuthorizationService } from './authorization.service';
@Injectable({
  providedIn: 'root',
})
export class WidgetsService {
  private readonly apiUrl = environment.apiHost; // Use HTTPS and secure URLs
  private readonly endPoints = apiUrl;
  private userProfile: any;
  configData: any = config;
  newsId: string = '';
  switchedAdvisor = computed(() => this._switchAdvisorService.switchedAdvisor());
  constructor(
    private _http: HttpClient,
    private _errorHandlerService: ErrorhandlerService,
    private _switchAdvisorService: switchAdvisorService,
    private _authorizationService: AuthorizationService,
  ) {
    this.userProfile = _authorizationService.getClaims();
  }

  fetchNews(body: requestPayload): Observable<NewsItem[]> {
    const httpHeaderOptions: { headers: HttpHeaders } = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    return this._http.post<NewsItem[]>(this.apiUrl + this.endPoints.getNews, body, httpHeaderOptions).pipe(
      catchError((error: HttpErrorResponse) => this._errorHandlerService.handleError(error)), // Use the centralized error handler
    );
  }
  getNewsItem(body: requestNewsItemPayload): Observable<any> {
    const httpHeaderOptions: { headers: HttpHeaders } = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    return this._http.post<any>(this.apiUrl + this.endPoints.getNewsItem, body, httpHeaderOptions).pipe(
      catchError((error: HttpErrorResponse) => this._errorHandlerService.handleError(error)), // Use the centralized error handler
    );
  }
  fetchRateCaps(body: requestforEmulationPayload): Observable<Ratecap> {
    const advisor = this.switchedAdvisor();
    const advisorUserId = advisor ? String(advisor.advisorId) : undefined;
    const httpHeaderOptions: { headers: HttpHeaders } = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    const requestBody =
      advisorUserId && this.userProfile?.sub.toLowerCase() !== advisorUserId.toLowerCase()
        ? { ...body, advisorUserId }
        : body;
    return this._http.post<Ratecap>(this.apiUrl + this.endPoints.getRatecaps, requestBody, httpHeaderOptions).pipe(
      catchError((error: HttpErrorResponse) => this._errorHandlerService.handleError(error)), // Use the centralized error handler
    );
  }

  fetchPromotionsList(body: requestPayload): Observable<Promotions[]> {
    const httpHeaderOptions: { headers: HttpHeaders } = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this._http.post<Promotions[]>(this.apiUrl + this.endPoints.getPromos, body, httpHeaderOptions).pipe(
      catchError((error: HttpErrorResponse) => this._errorHandlerService.handleError(error)), // Use the centralized error handler
      // Centralized error handling
    );
  }

  fetchProducts(body: requestPayload): Observable<Products> {
    const advisor = this.switchedAdvisor();
    const advisorUserId = advisor ? String(advisor.advisorId) : undefined;
    const httpHeaderOptions: { headers: HttpHeaders } = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    const requestBody =
      advisorUserId && this.userProfile?.sub.toLowerCase() !== advisorUserId.toLowerCase()
        ? { ...body, advisorUserId }
        : body;
    return this._http.post<Products>(this.apiUrl + this.endPoints.getProducts, requestBody, httpHeaderOptions).pipe(
      catchError((error: HttpErrorResponse) => this._errorHandlerService.handleError(error)), // Use the centralized error handler
    );
  }
}
